import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from './authSession';

interface RequireAuthProps {
  children: ReactNode;
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  if (!isAuthenticated()) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
